import { useState } from 'react';
import ChevronDown from 'svg/ChevronDown';
import ChevronUp from 'svg/ChevronUp';
import { ABOUT_PREVIEW_LENGTH } from '../../constants';

interface Props {
  description: string;
}

export default function ClubAbout({ description }: Props) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!description) {
    return null;
  }

  const isTruncatable = description.length > ABOUT_PREVIEW_LENGTH;
  const shown =
    isTruncatable && !isExpanded
      ? `${description.slice(0, ABOUT_PREVIEW_LENGTH).trimEnd()}…`
      : description;

  return (
    <section className="flex flex-col gap-4">
      <h2 className="typography-product-heading-compact-desktop text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
        About us
      </h2>
      <p className="typography-product-body whitespace-pre-line text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {shown}
      </p>
      {isTruncatable && (
        <button
          type="button"
          onClick={() => setIsExpanded((prev) => !prev)}
          className="typography-product-button-label-large flex items-center gap-1.5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary"
        >
          {isExpanded ? 'Show less' : 'Show more'}
          {isExpanded ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
        </button>
      )}
    </section>
  );
}
